import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to My Portfolio</h1>
        <p>Hi! I'm Arthur, a Web Developer from Holland.</p>
      </header>

      <section id="about">
        <h2>About Me</h2>
        <p>
          I am a passionate Web Developer with expertise in
          React, JavaScript, CSS. I love building interactive and user-friendly web applications.
        </p>
      </section>

      <section id="projects">
        <h2>My Projects</h2>
        <div className="project-list">
          {/* Add project details here */}
          <div className="project-item">
            <h3>Project 1: Android programming</h3>
            <a href="[Link to the project]" target="_blank" rel="noopener noreferrer">
              View Project
            </a>
          </div>

          <div className="project-item">
            <h3>Project 2: React programming</h3>
            <a href="[Link to the project]" target="_blank" rel="noopener noreferrer">
              View Project
            </a>
          </div>
        </div>
      </section>

      <section id="skills">
        <h2>Skills</h2>
        <ul>
          <li>JavaScript</li>
          <li>React.js</li>
          <li>Node.js</li>
          <li>HTML/CSS</li>
          <li>Git & GitHub</li>
          {/* Add more skills */}
        </ul>
      </section>

      <section id="contact">
        <h2>Contact Me</h2>
        <p>Email: <a href="mailto:your.email@example.com">arthur@gmail.com</a></p>
        <p>LinkedIn: <a href="[Your LinkedIn Profile]">Your LinkedIn</a></p>
        <p>GitHub: <a href="[Your GitHub Profile]">Your GitHub</a></p>
      </section>

      <footer>
        <p>&copy; 2024 Arthur. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;
